import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { IProcessStatus } from '@app/interfaces/process.interface';
import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { IOrg } from '../../domain/models/admin';
import { IAdminModalData } from '../../domain/models/admin-modal';
import { AdminOrganizationsService } from '../../services/admin-orgs.service';

@Component({
	selector: 'app-admin-rename-org-modal',
	templateUrl: './admin-rename-org-modal.component.html',
	styleUrls: ['./admin-rename-org-modal.component.scss'],
})
export class AdminRenameOrgModalComponent implements OnInit {
	@Input() data: IAdminModalData<{}>;

	inputName = new FormControl('', Validators.required);
	organization: IOrg;
	isLoading: boolean;

	constructor(
		private readonly adminOrgService: AdminOrganizationsService,
		private readonly toastService: WrapToasterService,
	) {}

	ngOnInit() {
		this.organization = this.data.options as IOrg;
		this.inputName.patchValue(this.organization.org_name);
	}

	save() {
		this.isLoading = true;
		const newName = this.inputName.value;
		const orgId = this.organization.org_id;
		this.adminOrgService.renameOrganization(orgId.toString(), newName).subscribe({
			next: (resp: { message: string }) => {
				this.isLoading = false;
				this.closeEvent({ message: IProcessStatus.saved });
			},
			error: () => {
				this.isLoading = false;
				this.toastService.showToast('error', 'Error', 'Ooops, something went wrong...');
			},
		});
	}

	closeEvent(e?: {}): void {}
}
